import { type FC, useState } from 'react';
import { ActionIcon, Box, Group, Stack, Text, Tooltip } from '@mantine/core';
import { IconCheck, IconCopy } from '@tabler/icons-react';

type ErrorNotificationMessageProps = {
    message?: string;
    traceId?: string | null;
};

export const ErrorNotificationMessage: FC<ErrorNotificationMessageProps> = ({ message, traceId }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        if (!traceId) {
            return;
        }

        try {
            await navigator.clipboard.writeText(traceId);
            setCopied(true);
            setTimeout(() => {
                return setCopied(false);
            }, 2000);
        } catch {}
    };

    return (
        <Stack gap='xs'>
            {message && (
                <Text
                    size='sm'
                    c='dimmed'
                >
                    {message}
                </Text>
            )}

            {traceId && (
                <Box>
                    <Group
                        gap='xs'
                        wrap='nowrap'
                    >
                        <Group gap={4}>
                            <Text
                                size='sm'
                                c='dimmed'
                            >
                                Код ошибки:
                            </Text>

                            <Text
                                size='sm'
                                maw={192}
                                truncate
                                fw={500}
                            >
                                {traceId}
                            </Text>
                        </Group>

                        <Tooltip
                            label={copied ? 'Скопировано' : 'Скопировать код ошибки'}
                            position='right'
                        >
                            <ActionIcon
                                size='sm'
                                variant='subtle'
                                color={copied ? 'green' : 'gray'}
                                onClick={handleCopy}
                            >
                                {copied ? <IconCheck size={14} /> : <IconCopy size={14} />}
                            </ActionIcon>
                        </Tooltip>
                    </Group>
                </Box>
            )}
        </Stack>
    );
};
